import { render, staticRenderFns } from "./placeAndEquipment.vue?vue&type=template&id=1f348980&scoped=true"
import script from "./placeAndEquipment.vue?vue&type=script&lang=js"
export * from "./placeAndEquipment.vue?vue&type=script&lang=js"
import style0 from "./placeAndEquipment.vue?vue&type=style&index=0&id=1f348980&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f348980",
  null
  
)

export default component.exports